import { useDialog } from 'primevue/usedialog'
import { useBootstrapVueModal } from '@/composables/useBootstrapVueModal'
import { openLikeDialog } from './like-dialog'
import { openReviewDialog } from './review-dialog'
// @ts-expect-error import path to avoid circular dependency issues
import FeedbackModal from '@/components/FeedbackModal.vue'
import constants from '@/constants'

const RATING_KEY = 'consoleRatingPrefs'
const USES_UNTIL_PROMPT = 25
const VERSION = constants().version

let _modalController = null as ReturnType<typeof useBootstrapVueModal> | null
let _dialog = null as ReturnType<typeof useDialog> | null

function getRatingPrefs () {
  const raw = localStorage.getItem(RATING_KEY)
  if (!raw) return { uses: 0, lastPrompt: 0, rated: false, declined: false, lastVersion: '' }
  try {
    return JSON.parse(raw)
  } catch {
    return { uses: 0, lastPrompt: 0, rated: false, declined: false, lastVersion: '' }
  }
}

function setRatingPrefsLocal (prefs: object) {
  localStorage.setItem(RATING_KEY, JSON.stringify(prefs))
}

export function initRating(modalController: ReturnType<typeof useBootstrapVueModal>, dialog: ReturnType<typeof useDialog>) {
  _modalController = modalController
  _dialog = dialog
}

export function startRatingWorkflow(immediately: boolean = false) {

  const prefs = getRatingPrefs()
  const now = Date.now()
  // const daysSinceLastPrompt = (now - (prefs.lastPrompt || 0)) / (1000 * 60 * 60 * 24)

  if (!immediately) {
    if (prefs.rated) return
    if (prefs.declined /* && prefs.lastVersion === VERSION */) return
  }

  prefs.rated = false
  prefs.declined = false
  prefs.uses = (prefs.uses || 0) + 1
  prefs.lastPrompt = now
  setRatingPrefsLocal(prefs)

  if (!immediately) {
    // If we are not prompting immediately, check if we should prompt based on usage and time since last prompt
    if (prefs.uses < USES_UNTIL_PROMPT) return
    // if (prefs.lastPrompt && daysSinceLastPrompt < DAYS_UNTIL_PROMPT) return
  }

  openLikeDialog({
    dialog: _dialog!,
    onLikeYes: () => {
      openReviewDialog({
        dialog: _dialog!,
        onRemindLater: () => {
          prefs.lastPrompt = Date.now()
          prefs.uses = 0
          setRatingPrefsLocal(prefs)
        },
        onReviewed: () => {
          prefs.rated = true
          setRatingPrefsLocal(prefs)
        },
        onDecline: () => {
          prefs.declined = true
          prefs.lastVersion = VERSION
          setRatingPrefsLocal(prefs)
        }
      })
    },
    onLikeNo: () => {
      prefs.declined = true
      prefs.lastVersion = VERSION
      setRatingPrefsLocal(prefs)
      _modalController?.showModal?.({ component: FeedbackModal })
    }
  })
}

export function navigateToReviewSite(): void {
  window.open('https://reviews.capterra.com/products/new/009e93ec-57ad-4412-87b4-616bc21bce0b/', '_fareclock-review');
}
